import virtual from "@pdfking/workflow/vue/3/virtual"
import start_request from "../navigation/start_request"

export default virtual({
  methods: {
    push_state(url: string) {
      console.info(`pushing url to history: ${url}`)
      window.history.pushState({ url }, "", url)
    },
    replace_state(url: string) {
      console.info(`replace url to history: ${url}`)
      window.history.replaceState({ url }, "", url)
    },
  },
})

window.onpopstate = (_e: PopStateEvent) => {
  if (!window.location.hash)
    start_request(window.location.href, {
      change_location: false,
      data: null,
    })
}
